var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"button main-font dark-bg-text",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('h1',[_vm._v(_vm._s(_vm.mainText))]),_c('h2',[_vm._v(_vm._s(_vm.subText))])])}
var staticRenderFns = []

export { render, staticRenderFns }